module.exports = "/_next/static/images/ef4996a4cd73edac8cf424020e4f00a3-group-man-building@0.75x.jpg.webp";